<template>
  <footer class="footer">
    <div class="limit-grid">
      <div class="footer__fisrt-line">
        <div class="footer__fisrt-line__wrapper">
          <img src="@/assets/logo-footer.svg" alt="Logo Coritiba" />
          <div class="footer__fisrt-line__phone">
            <section class="footer__fisrt-line__phone__content">
              <p>Central de Vendas</p>
              <a href="tel:08007292078">0800 729 2078</a>
            </section>
            <section class="footer__fisrt-line__phone__content">
              <p>SAC</p>
              <a href="tel:08002838916">0800 283 8916</a>
            </section>
          </div>
          <div class="footer__fisrt-line__social">
            <a
              href="https://www.facebook.com/cdtcoritiba"
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11.003"
                height="21.187"
                viewBox="0 0 11.003 21.187"
              >
                <path
                  d="M194.552,515.312v-9.664H197.8l.486-3.766h-3.73v-2.4c0-1.091.3-1.833,1.866-1.833h1.995v-3.369a26.8,26.8,0,0,0-2.907-.148c-2.875,0-4.844,1.755-4.844,4.979v2.778H187.41v3.766h3.252v9.664Z"
                  transform="translate(-187.41 -494.125)"
                />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/cartaodetodoscoritiba"
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19.472"
                height="18.586"
                viewBox="0 0 19.472 18.586"
              >
                <g transform="translate(0 0)">
                  <path
                    d="M345.951,505.2H338.49a6.013,6.013,0,0,1-6.006-6.006v-6.575a6.012,6.012,0,0,1,6.006-6.005h7.461a6.012,6.012,0,0,1,6.005,6.005V499.2A6.013,6.013,0,0,1,345.951,505.2Zm-7.461-17.251a4.676,4.676,0,0,0-4.671,4.671V499.2a4.676,4.676,0,0,0,4.671,4.671h7.461a4.676,4.676,0,0,0,4.671-4.671v-6.575a4.676,4.676,0,0,0-4.671-4.671Z"
                    transform="translate(-332.484 -486.618)"
                  />
                  <g transform="translate(4.391 3.947)">
                    <path
                      d="M363.426,520.322a5.346,5.346,0,1,1,5.346-5.346A5.352,5.352,0,0,1,363.426,520.322Zm0-9.357a4.011,4.011,0,1,0,4.011,4.011A4.016,4.016,0,0,0,363.426,510.964Z"
                      transform="translate(-358.08 -509.63)"
                    />
                  </g>
                  <g transform="translate(13.891 3.002)">
                    <path
                      d="M415.682,505.23a1.109,1.109,0,1,1-1.109-1.11A1.109,1.109,0,0,1,415.682,505.23Z"
                      transform="translate(-413.464 -504.12)"
                    />
                  </g>
                </g>
              </svg>
            </a>
            <a href="https://twitter.com/cdtcoritiba" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19.78"
                height="16.074"
                viewBox="0 0 19.78 16.074"
              >
                <path
                  id="twitter"
                  d="M19.78,4.151a8.1,8.1,0,0,1-2.331.639,4.065,4.065,0,0,0,1.784-2.245,8.129,8.129,0,0,1-2.577.985,4.061,4.061,0,0,0-6.916,3.7A11.52,11.52,0,0,1,1.377,2.991,4.063,4.063,0,0,0,2.632,8.409,4.041,4.041,0,0,1,.8,7.9a4.061,4.061,0,0,0,3.255,4.03A4.067,4.067,0,0,1,2.217,12a4.061,4.061,0,0,0,3.791,2.818A8.159,8.159,0,0,1,0,16.5a11.488,11.488,0,0,0,6.221,1.823A11.477,11.477,0,0,0,17.755,6.252a8.262,8.262,0,0,0,2.025-2.1Z"
                  transform="translate(0 -2.248)"
                  fill="#000"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div class="footer__second-line">
        <p>
          * Cartão de desconto não é plano de saúde, não garante e não se
          responsabiliza pelos serviços oferecidos e pelo pagamento das
          despesas, nem assegura desconto em todos os serviços obrigatoriamente
          garantidos por plano de saúde. Tudo o que o cliente usar ou comprar
          será por ele pago ao prestador, assegurando-se apenas os preços e
          descontos que constam na relação de empresas e serviços conveniados
          disponibilizada no site www.cartaodetodos.com.br. O atendimento será
          em até 15 dias, mediante disponibilidade na clínica. Consulte a
          clínica parceira para as especialidades disponíveis e condições para
          marcar as consultas.
        </p>
      </div>
      <div class="footer__third-line">
        <div class="footer__third-line__links">
          <ul>
            <li>
              <p>Um produto</p>
            </li>
            <li>
              <a href="https://cartaodetodos.com.br/" target="_blank"
                >Cartão de TODOS ©</a
              >
            </li>
            <li>
              <a href="https://cartaodetodos.com.br/wp-content/uploads/2023/04/Contrato-de-AdCDT2023.pdf" target="_blank"
                >Contrato de adesão</a
              >
            </li>
            <li>
              <a
                href="https://www.gotcha.com.br/"
                class="nostyle"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="29.378"
                  height="19.002"
                  viewBox="0 0 29.378 19.002"
                >
                  <g
                    id="Grupo_3047"
                    data-name="Grupo 3047"
                    transform="translate(-189.776 -114.679)"
                  >
                    <g
                      id="Grupo_3046"
                      data-name="Grupo 3046"
                      transform="translate(189.776 114.679)"
                    >
                      <path
                        id="Caminho_5086"
                        data-name="Caminho 5086"
                        d="M214.775,122.365h-7.637a1.787,1.787,0,0,0-1.312.515,1.654,1.654,0,0,0-.551,1.273,1.872,1.872,0,0,0,.533,1.314,1.913,1.913,0,0,0,1.312.552h3.718a5.861,5.861,0,1,1-5.553-7.685,5.7,5.7,0,0,1,3.5,1.18l2.872-2.34a9.376,9.376,0,0,0-6.372-2.491,9.5,9.5,0,1,0,9.32,11.336,12.792,12.792,0,0,0,.171-1.827Z"
                        transform="translate(-195.776 -114.68)"
                      />
                      <g
                        id="Grupo_3045"
                        data-name="Grupo 3045"
                        transform="translate(19.257)"
                      >
                        <path
                          id="Caminho_5087"
                          data-name="Caminho 5087"
                          d="M225.054,114.679l-4.966,12.488.007,0a1.78,1.78,0,0,0,.016,1.4,1.707,1.707,0,0,0,.992.973,1.724,1.724,0,0,0,1.4-.021,1.8,1.8,0,0,0,.978-1l4.967-12.49Z"
                          transform="translate(-218.33 -114.679)"
                        />
                        <path
                          id="Caminho_5088"
                          data-name="Caminho 5088"
                          d="M220.576,132.577a1.828,1.828,0,1,0,1.023,2.372A1.829,1.829,0,0,0,220.576,132.577Z"
                          transform="translate(-218.073 -117.102)"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- <TheChat /> -->
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss">
.footer {
  color: $color-white;
  background: $color-primary;
  padding-top: 40px;
  @include media(">=tablet") {
    padding: 0;
  }
  &__fisrt-line {
    @include media(">=tablet") {
      padding-top: 78.3px;
    }
    &__wrapper {
      display: grid;
      grid-template-columns: 1fr;
      list-style: none;
      align-items: center;
      grid-gap: 18px;
      @include media(">=tablet") {
        grid-template-columns: min-content auto min-content;
      }
      img {
        justify-self: center;
        @include media(">=tablet") {
          justify-self: initial;
        }
      }
    }
    &__phone {
      max-width: 560px;
      margin: 0px auto;
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 30px;
      @include media(">=tablet") {
        grid-template-columns: auto auto;
        grid-gap: 92px;
      }
      &__content {
        text-align: center;
        p {
          text-align: center;
          font-size: 15px;
          line-height: 18px;
          font-weight: 100;
          text-transform: uppercase;
          color: $color-white;
        }
        a {
          font-family: "Ubuntu", sans-serif;
          font-size: 34px;
          line-height: 42px;
          font-weight: 700;
          margin-top: 4px;
          color: $color-white;
          text-decoration: none;
          transition: 0.3s ease-in-out;
          &:hover {
            color: $color-yellow;
          }
        }
      }
    }

    &__social {
      display: grid;
      grid-template-columns: repeat(3, max-content);
      grid-gap: 18px;
      justify-self: center;
      @include media(">=tablet") {
        justify-self: initial;
      }
      a {
        width: 28.89px;
        height: 28.89px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: $color-yellow;
        transition: 0.3s ease-in-out;
        border: 1px solid $color-yellow;

        path {
          fill: $color-primary;
        }
        &:hover {
          background: $color-primary;
          path {
            fill: $color-yellow;
          }
        }
      }
    }
  }

  &__second-line {
    padding-top: 34.1px;

    p {
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      color: $color-white;
      @include media(">=tablet") {
        text-align: left;
      }
    }
  }

  &__third-line {
    display: inline-flex;
    border-top: 1px solid $color-white;
    width: 100%;
    padding: 26.5px 0 30px;
    margin-top: 26.5px;
    text-align: center;

    &__links {
      width: 100%;

      ul {
        padding: initial;
        list-style: none;
        margin-left: auto;
        display: grid;
        grid-template-columns: max-content auto;
        grid-gap: 13px;
        width: 100%;
        align-items: center;
        @include media(">=tablet") {
          display: inline-flex;
        }
        li {
          @include media(">=tablet") {
            margin-right: 20px;
          }

          &:nth-child(1) {
            margin-left: auto;
          }

          &:nth-child(3) {
            margin-left: auto;
            margin-right: auto;
            grid-column: span 2;
            text-align: center;
            margin-top: 30px;
            @include media(">=tablet") {
              margin-right: 0px;
              margin-top: initial;
              grid-column: initial;
            }
          }
        }

        p {
          font-size: 14px;
          color: $color-white;
        }

        a {
          &:not(.nostyle) {
            padding: 14px 35px;
            background: $color-yellow;
            color: $color-black;
            font-weight: 700;
            font-size: 14px;
            border-radius: 31px;
            text-decoration: none;
            transition: 0.3s ease-in-out;
            display: block;
            border: 2px solid $color-yellow;
            @include media(">=tablet") {
              &:hover {
                background: $color-black;
                color: $color-yellow;
              }
            }
          }
          &.nostyle {
            svg path {
              transition: 0.3s ease-in-out;
              fill: $color-yellow;
            }
            &:hover {
              svg path {
                fill: $color-white;
              }
            }
          }
        }
      }
    }
  }
}
</style>
